import React from "react";
import classnames from "classnames";

import Icon from "components/Icon";
import Text, { useGetText } from "components/Text";
import { getDescription } from "utils/permission";

import styles from "./Permission.scss";

const categoryIcons = {
  permitted: "check-circle",
  conditional: "do-not-enter",
  other: "do-not-enter",
  prohibited: "times-hexagon",
};

const Permission = ({
  isZoningEnabled,
  permission,
  category,
  unansweredFieldCount,
  withoutUnansweredQuestions = false,
}) => {
  const getText = useGetText();
  if (!isZoningEnabled || !category) return null;

  const translatedCategoryName = getText(`guides.location.${category}`);

  return (
    <div>
      <div className={classnames(styles[category], styles.title)}>
        <Icon icon={categoryIcons[category]} />
        <span>{translatedCategoryName}</span>
      </div>
      <div className={styles.content}>
        {(withoutUnansweredQuestions || unansweredFieldCount === 0) && getDescription(permission)}

        <div className={styles.disclaimer}>
          <Text t="fields.zoning.disclaimer" />
        </div>

        {!withoutUnansweredQuestions && unansweredFieldCount > 0 && (
          <Text
            t="fields.zoning.unanswered_questions"
            category={translatedCategoryName}
            unansweredFieldCount={unansweredFieldCount}
          />
        )}
      </div>
    </div>
  );
};

export default Permission;
